<aside class="sidebar" [class.collapsed]="collapsed" [class.mobile-open]="mobileOpen">

  <!-- ── Brand bar ──────────────────────────────────────────────────────────── -->
  <div class="sidebar-brand">
    <div class="brand-icon-wrap">
      <svg class="brand-logo" viewBox="0 0 48 48" width="24" height="24"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="spTop" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#5fd3e6" />
            <stop offset="100%" stop-color="#38a7f0" />
          </linearGradient>
          <linearGradient id="spBottom" x1="1" y1="1" x2="0" y2="0">
            <stop offset="0%" stop-color="#1e3a8a" />
            <stop offset="100%" stop-color="#2563eb" />
          </linearGradient>
        </defs>
        <!-- Two-tone interlocking "S": light-cyan upper swoosh + deep-blue lower
             swoosh, forming an S the way the SmartPay brand mark does. -->
        <!-- Upper swoosh (top of the S): hooks from upper-right down to centre -->
        <path d="M38 15c-2.2-2.3-5.6-3.6-9.6-3.6-7 0-12.4 4-12.4 10.1 0 3.2 1.5 5.6 4.2 7.2 1-3.2 4.1-5.3 8.6-5.3 3.6 0 6.7 1.1 9.2 3.1V15z"
          fill="url(#spTop)" />
        <!-- Lower swoosh (bottom of the S): hooks from lower-left up to centre -->
        <path d="M10 33c2.2 2.3 5.6 3.6 9.6 3.6 7 0 12.4-4 12.4-10.1 0-3.2-1.5-5.6-4.2-7.2-1 3.2-4.1 5.3-8.6 5.3-3.6 0-6.7-1.1-9.2-3.1V33z"
          fill="url(#spBottom)" />
      </svg>
    </div>
    <div class="brand-titles" *ngIf="!collapsed">
      <span class="brand-text">SmartPay</span>
      <span class="brand-tagline">Payroll · People · Compliance</span>
    </div>
    <button class="collapse-btn" *ngIf="!collapsed"
      (click)="toggle.emit()" title="Collapse sidebar" aria-label="Collapse sidebar">
      <i class="pi pi-chevron-left"></i>
    </button>
  </div>

  <!-- ── Expand button (collapsed state) ───────────────────────────────────── -->
  <button class="expand-btn" *ngIf="collapsed"
    (click)="toggle.emit()" title="Expand sidebar" aria-label="Expand sidebar">
    <i class="pi pi-chevron-right"></i>
  </button>

  <!-- ── Navigation ─────────────────────────────────────────────────────────── -->
  <nav #sidebarNav class="sidebar-nav" role="navigation" aria-label="Main navigation">

    <!-- Fixed MAIN section: Dashboard is always present -->
    <div class="nav-section">
      <span class="nav-section-label" *ngIf="!collapsed">MAIN</span>
      <a routerLink="/dashboard" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'Dashboard' : ''">
        <span class="nav-icon"><i class="pi pi-home"></i></span>
        <span class="nav-label" *ngIf="!collapsed">Dashboard</span>
      </a>
    </div>

    <!-- ── Dynamic menu section ─────────────────────────────────────────────── -->
    <div class="nav-section" *ngIf="menuLoading">
      <div class="menu-loading" *ngIf="!collapsed">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading menus…</span>
      </div>
      <div class="menu-loading-icon" *ngIf="collapsed">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
    </div>

    <div class="nav-section dynamic-section" *ngIf="!menuLoading && menuNodes.length > 0">
      <span class="nav-section-label" *ngIf="!collapsed">MENU</span>

      <!-- Recursive menu rendering via ng-template -->
      <ng-container
        *ngTemplateOutlet="menuTree; context: { nodes: menuNodes, depth: 0 }">
      </ng-container>
    </div>

    <!-- Empty state — only shown when menus loaded but returned nothing -->
    <div class="nav-section" *ngIf="!menuLoading && menuNodes.length === 0 && auth.isAuthenticated()">
      <div class="menu-empty" *ngIf="!collapsed">
        <i class="pi pi-lock"></i>
        <span>No menus available</span>
      </div>
    </div>

    <!-- ── Fixed SYSTEM section — SYSADMIN/ADMINISTRATOR only ─────────────── -->
    <!-- <div class="nav-section"
      *ngIf="auth.isSysAdmin() || auth.isAdministrator()">
      <span class="nav-section-label" *ngIf="!collapsed">SYSTEM</span>

      <a routerLink="/workflow" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'Workflow' : ''">
        <span class="nav-icon"><i class="pi pi-sitemap"></i></span>
        <span class="nav-label" *ngIf="!collapsed">Workflow</span>
      </a>

      <a routerLink="/users" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'User Management' : ''">
        <span class="nav-icon"><i class="pi pi-user"></i></span>
        <span class="nav-label" *ngIf="!collapsed">User Management</span>
      </a>

      <a routerLink="/user-rights" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'User Rights' : ''">
        <span class="nav-icon"><i class="pi pi-lock"></i></span>
        <span class="nav-label" *ngIf="!collapsed">User Rights</span>
      </a>

      <a *ngIf="auth.isSysAdmin()" routerLink="/sessions" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'User Sessions' : ''">
        <span class="nav-icon"><i class="pi pi-desktop"></i></span>
        <span class="nav-label" *ngIf="!collapsed">User Sessions</span>
      </a>

      <a routerLink="/settings" routerLinkActive="active" class="nav-item"
        [title]="collapsed ? 'Settings' : ''">
        <span class="nav-icon"><i class="pi pi-cog"></i></span>
        <span class="nav-label" *ngIf="!collapsed">Settings</span>
      </a>
    </div> -->

  </nav>

  <!-- ── Mobile close button ───────────────────────────────────────────────── -->
  <button class="mobile-close-btn" (click)="mobileClose.emit()" aria-label="Close menu">
    <i class="pi pi-times"></i>
  </button>

</aside>

<!-- ═══════════════════════════════════════════════════════════════════════════
     Recursive menu-tree template.
     Renders any depth: root nodes, their children, grandchildren, etc.
     No maximum nesting level is enforced.
     ═══════════════════════════════════════════════════════════════════════ -->
<ng-template #menuTree let-nodes="nodes" let-depth="depth">
  <ng-container *ngFor="let node of nodes; trackBy: trackByMenuId">

    <!-- ── Parent / section node (has children, no direct route) ─────────── -->
    <ng-container *ngIf="node.children.length > 0">
      <div
        class="nav-item nav-parent"
        [class.active]="isActive(node)"
        [class.expanded]="node.expanded"
        [style.padding-left.px]="collapsed ? null : 20 + depth * 12"
        (click)="toggleNode(node, $event)"
        role="button"
        tabindex="0"
        (keydown.enter)="toggleNode(node, $event)"
        [title]="collapsed ? node.displayName : ''"
        [attr.aria-expanded]="node.expanded"
        [attr.aria-label]="node.displayName"
      >
        <span class="nav-icon">
          <i [class]="node.icon || 'pi pi-folder'"></i>
        </span>
        <span class="nav-label" *ngIf="!collapsed">{{ node.displayName }}</span>
        <span class="nav-chevron" *ngIf="!collapsed">
          <i class="pi" [class.pi-chevron-down]="node.expanded" [class.pi-chevron-right]="!node.expanded"></i>
        </span>
      </div>

      <!-- Children — shown when expanded (or always when collapsed for tooltip) -->
      <div class="nav-children" [class.expanded]="node.expanded" *ngIf="!collapsed">
        <ng-container
          *ngTemplateOutlet="menuTree; context: { nodes: node.children, depth: depth + 1 }">
        </ng-container>
      </div>

      <!-- In collapsed mode, show children inline without indentation -->
      <ng-container *ngIf="collapsed">
        <ng-container
          *ngTemplateOutlet="menuTree; context: { nodes: node.children, depth: 0 }">
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- ── Leaf node (has a route, no children) ───────────────────────────── -->
    <ng-container *ngIf="node.children.length === 0">

      <!-- Routable leaf. Active state uses the resolved best-match route (not
           routerLinkActive), so a shorter sibling path like /employees doesn't
           also highlight when a more specific route like /employees/details-import
           is open. -->
      <a *ngIf="node.routePath"
        [routerLink]="node.routePath"
        [class.active]="isActive(node)"
        class="nav-item"
        [style.padding-left.px]="collapsed ? null : 20 + depth * 12"
        [title]="collapsed ? node.displayName : ''"
        [attr.aria-label]="node.displayName"
      >
        <span class="nav-icon">
          <i [class]="node.icon || 'pi pi-circle'"></i>
        </span>
        <span class="nav-label" *ngIf="!collapsed">{{ node.displayName }}</span>
      </a>

      <!-- Non-routable leaf — a "coming soon" placeholder (no screen yet). Shown
           dimmed with a Soon badge; does not navigate. -->
      <div *ngIf="!node.routePath"
        class="nav-item nav-placeholder"
        [style.padding-left.px]="collapsed ? null : 20 + depth * 12"
        [title]="collapsed ? (node.displayName + ' (coming soon)') : ''"
      >
        <span class="nav-icon">
          <i [class]="node.icon || 'pi pi-minus'"></i>
        </span>
        <span class="nav-label" *ngIf="!collapsed">{{ node.displayName }}</span>
        <span class="nav-soon" *ngIf="!collapsed">Soon</span>
      </div>

    </ng-container>

  </ng-container>
</ng-template>
